// Merkan · Englisches Wörterbuch für das Rechnungswesen (src/seiten/rw). Der Belegdruck nutzt DRUCK in rw-hilfen.ts (Kundensprache).
export default {
  // Seitenrahmen und Reiter
  'Rechnungswesen': 'Accounting',
  'Finanzen': 'Finance',
  'Belege': 'Documents',
  'Offene Posten': 'Open Items',
  'Zahlungen': 'Payments',
  'Mahnwesen': 'Dunning',
  'Rechnungsjournal aller Belege mit Filter und Export': 'Invoice journal of all documents with filters and export',
  'Offene Ausgangsrechnungen je Kunde mit Fälligkeit': 'Outstanding sales invoices by customer with due dates',
  'Zahlungseingänge zu Ausgangsrechnungen': 'Incoming payments against sales invoices',
  'Zahlungserinnerungen und Mahnungen als Vorschlag': 'Suggested payment reminders and dunning letters',

  // Teilarten und Zahlungsarten
  'Anzahlung': 'Advance payment',
  'Schlussrechnung': 'Final Invoice',
  'Anzahlungsrechnung': 'Advance Invoice',
  'Überweisung': 'Bank transfer',
  'Lastschrift': 'Direct debit',
  'Bar': 'Cash',
  'Verrechnung': 'Offset',
  'Sonstige': 'Other',

  // Beleg
  'Beleg': 'Document',
  'Beleg nicht gefunden': 'Document not found',
  'Dieser Beleg existiert nicht oder ist für dich nicht sichtbar.': 'This document does not exist or is not visible to you.',
  'Zum Rechnungsjournal': 'Go to invoice journal',
  'Entwurf': 'Draft',
  'Fassung {n}': 'Revision {n}',
  'Teilenummer': 'Part number',
  'Bezeichnung': 'Description',
  'Menge': 'Qty',
  'Einheit': 'UoM',
  'Einzelpreis': 'Unit price',
  'Rabatt': 'Discount',
  'USt': 'VAT',
  'Position löschen': 'Delete line item',
  'Position gelöscht.': 'Line item deleted.',
  'Bitte eine Bezeichnung eintragen.': 'Please enter a description.',
  'Menge, Preis, Rabatt und USt bitte als Zahl eintragen.': 'Please enter quantity, price, discount and VAT as numbers.',
  'Das Belegdatum ist Pflicht.': 'The document date is required.',
  'Belegkopf gespeichert.': 'Document header saved.',
  "Ein Beleg ohne Positionen kann nicht ausgestellt werden.": "A document without line items cannot be issued.",
  '{art} festschreiben?': 'Finalise {art}?',
  'Der Beleg erhält die nächste Nummer aus dem Nummernkreis und wird mit den Kundendaten von heute eingefroren. Danach ist er nach GoBD unveränderbar, Korrekturen sind nur über Storno und Neubeleg möglich.':
    'The document receives the next number from the number range and is frozen with today\'s customer data. It can then no longer be changed (GoBD); corrections are only possible by cancellation and a new document.',
  'Summe brutto:': 'Total gross:',
  'Festschreiben': 'Finalise',
  '{art} {nummer} festgeschrieben.': '{art} {nummer} finalised.',
  '{titel} stornieren?': 'Cancel {titel}?',
  "Es wird eine Gutschrift mit negativen Mengen erzeugt, die auf {nummer} verweist, und sofort gebucht. Die Rechnung erhält den Status Storniert.": "A credit note with negative quantities referring to {nummer} is created and posted immediately. The invoice is set to Cancelled.",
  'Der Beleg erhält den Status Storniert. Er bleibt unverändert erhalten.': 'The document will be set to Cancelled. It is retained unchanged.',
  'Auf diesen Beleg sind bereits {betrag} gebucht. Eine Rückzahlung bitte gesondert erfassen.': '{betrag} has already been booked against this document. Please record any refund separately.',
  'Stornieren': 'Cancel document',
  "Rechnung storniert, Gutschrift gebucht.": "Invoice cancelled, credit note posted.",
  'Beleg storniert.': 'Document cancelled.',
  'Entwurf löschen?': 'Delete draft?',
  'Der Entwurf und seine Positionen werden entfernt. Es wurde noch keine Nummer vergeben.': 'The draft and its line items will be removed. No number has been assigned yet.',
  'Löschen': 'Delete',
  'Entwurf gelöscht.': 'Draft deleted.',
  'Bearbeiten': 'Edit',
  'Druckansicht': 'Print view',
  'Bezug': 'Reference',
  'Zahlung buchen': 'Book payment',
  'Drucken / PDF': 'Print / PDF',
  'Dieser Beleg wurde am {datum} storniert.': 'This document was cancelled on {datum}.',
  'Entwurf ohne Nummer. Änderungen werden direkt gespeichert. Steuerart des Kunden: {steuerart}.': 'Draft without number. Changes are saved immediately. Customer tax category: {steuerart}.',
  'Positionen': 'Line items',
  'Felder speichern beim Verlassen': 'Fields save when you leave them',
  'Pos.': 'Item',
  'Rabatt %': 'Discount %',
  'USt %': 'VAT %',
  'Betrag': 'Amount',
  'Artikel suchen': 'Search items',
  '0,00': '0.00',
  'Hinzufügen': 'Add',
  'Summe netto': 'Net total',
  'Umsatzsteuer': 'VAT',
  'Gesamt brutto': 'Total gross',
  'Kopf und Texte': 'Header and texts',
  'Speichern': 'Save',
  'Belegdatum *': 'Document date *',
  'Leistungsdatum': 'Date of supply',
  'Leer bedeutet Belegdatum': 'Empty means document date',
  'Fällig am': 'Due on',
  'Leer bedeutet laut Zahlungsziel': 'Empty means according to payment terms',
  'Ihr Zeichen': 'Your reference',
  'Bestellnummer des Kunden': 'Customer order number',
  'Kopftext': 'Header text',
  'Fußtext': 'Footer text',
  'Der Steuerhinweis zur Steuerart wird automatisch ergänzt': 'The tax note for the tax category is added automatically',
  'Noch keine Zahlungen gebucht': 'No payments booked yet',
  'Datum': 'Date',
  'Art': 'Type',
  'Referenz': 'Reference',
  'Rechnungsbetrag': 'Invoice amount',
  'Bezahlt': 'Paid',
  'Offen': 'Open',
  'Bezahlt am': 'Paid on',

  // Rechnungsjournal
  'Rechnungsjournal': 'Invoice journal',
  'alle': 'all',
  'Belegart': 'Document type',
  'Nummer': 'Number',
  'Status': 'Status',
  'Belegdatum': 'Document date',
  'Kundennummer': 'Customer no.',
  'Kunde': 'Customer',
  'Netto': 'Net',
  'Brutto': 'Gross',
  'Währung': 'Currency',
  'Bitte einen Kunden wählen.': 'Please select a customer.',
  'Entwurf angelegt.': 'Draft created.',
  '{von} bis {bis}': '{von} to {bis}',
  'Beginn': 'start',
  'heute': 'today',
  'alle Belege': 'all documents',
  'Nummer, Kunde, Ihr Zeichen': 'Number, customer, your reference',
  'Alle Belegarten': 'All document types',
  'Jeder Status': 'Any status',
  'Alle Kunden': 'All customers',
  'Zeitraum': 'Period',
  'Dieser Monat': 'This month',
  'Letzter Monat': 'Last month',
  'Dieses Quartal': 'This quarter',
  'Dieses Jahr': 'This year',
  'Gesamter Zeitraum': 'All time',
  'Frei wählen': 'Custom',
  'Von': 'From',
  'bis': 'to',
  'Bis': 'To',
  'CSV': 'CSV',
  'Drucken': 'Print',
  'Neuer Beleg': 'New document',
  'Keine Belege im gewählten Zeitraum': 'No documents in the selected period',
  'Filter oder Zeitraum anpassen.': 'Adjust the filters or period.',
  'Fällig': 'Due',
  "Wird als Entwurf angelegt, die Nummer folgt beim Ausstellen oder Buchen": "Created as a draft; the number is assigned when the document is issued or posted",
  'Abbrechen': 'Cancel',
  'Entwurf anlegen': 'Create draft',
  'Kunde *': 'Customer *',
  'Bitte wählen': 'Please select',
  'Rechnungen entstehen in der Regel aus dem Vorgang. Hier angelegte Belege haben keinen Vorgangsbezug.': 'Invoices are normally created from the case. Documents created here are not linked to a case.',
  '{n} Beleg exportiert.': '{n} document exported.',
  '{n} Belege exportiert.': '{n} documents exported.',
  '{n} Beleg': '{n} document',
  '{n} Belege': '{n} documents',

  // Offene Posten
  'Offene_Posten': 'Open_Items',
  'Rechnung': 'Invoice',
  'Teilart': 'Instalment',
  'Tage überfällig': 'Days overdue',
  'Davon überfällig': 'Of which overdue',
  'Kunden mit offenen Posten': 'Customers with open items',
  'Summe stimmt mit dem Journal überein': 'Total matches the journal',
  'Rechnung oder Kunde': 'Invoice or customer',
  'Alle': 'All',
  'Überfällig': 'Overdue',
  'Fällig in 14 Tagen': 'Due within 14 days',
  'Keine offenen Posten': 'No open items',
  'Keine Treffer': 'No matches',
  'davon überfällig': 'of which overdue',
  'heute fällig': 'due today',
  'Summe Auswahl': 'Total of selection',
  'Summe gesamt': 'Grand total',
  '{n} Rechnung': '{n} invoice',
  '{n} Rechnungen': '{n} invoices',
  '{n} Tag überfällig': '{n} day overdue',
  '{n} Tage überfällig': '{n} days overdue',
  'in {n} Tag': 'in {n} day',
  'in {n} Tagen': 'in {n} days',

  // Zahlungen und Zahlung buchen
  'Beleg, Kunde, Referenz, Betrag': 'Document, customer, reference, amount',
  'Jahr': 'Year',
  'Alle Jahre': 'All years',
  'Zahlung erfassen': 'Record payment',
  'Keine Zahlungen im gewählten Zeitraum': 'No payments in the selected period',
  '{n} Zahlung': '{n} payment',
  '{n} Zahlungen': '{n} payments',
  'Bitte die Rechnung wählen.': 'Please select the invoice.',
  'Bitte einen Vorschlag wählen, um die Zahlung einer Rechnung zuzuordnen.': 'Please select a suggestion to allocate the payment to an invoice.',
  'Bitte einen Betrag eintragen.': 'Please enter an amount.',
  'Der Betrag ist höher als der offene Rest von {betrag}.': 'The amount exceeds the outstanding balance of {betrag}.',
  'Teilzahlung gebucht, offen bleiben {betrag}.': 'Part payment booked, {betrag} remains outstanding.',
  'Zahlung gebucht, {nummer} ist bezahlt.': 'Payment booked, {nummer} is paid.',
  'Zahlung zu {nummer} buchen': 'Book payment for {nummer}',
  'Bucht': 'Booking',
  'Auf {nummer} buchen': 'Book to {nummer}',
  'Buchen': 'Book',
  'Betrag in Euro *': 'Amount in EUR *',
  'Verwendungszweck': 'Payment reference',
  'Wie auf dem Kontoauszug, wird als Referenz gespeichert': 'As shown on the bank statement; saved as the reference',
  'z. B. RE-2026-00004 Anzahlung Nordwerk': 'e.g. RE-2026-00004 advance payment Nordwerk',
  'Zuordnung zu offener Rechnung': 'Allocation to open invoice',
  'Zuordnung': 'Allocation',
  'sucht': 'searching',
  'Keine offene Rechnung vorhanden.': 'No open invoice available.',
  'bester Treffer': 'best match',
  'fällig {datum}': 'due {datum}',
  'Keine Übereinstimmung mit Betrag oder Verwendungszweck': 'No match with amount or payment reference',
  'Rechnungsnummer im Verwendungszweck': 'Invoice number in payment reference',
  'Vorgangsnummer im Verwendungszweck': 'Case number in payment reference',
  'Betrag passt genau': 'Exact amount match',
  'Kunde im Verwendungszweck': 'Customer in payment reference',
  'Offen:': 'Outstanding:',
  'Notiz': 'Note',
  'Teilzahlung: Es bleiben {betrag} offen.': 'Part payment: {betrag} remains outstanding.',
  '{n} offene Rechnung': '{n} open invoice',
  '{n} offene Rechnungen': '{n} open invoices',

  // Mahnwesen (Oberfläche; die Mahntexte selbst folgen der Kundensprache)
  'Zahlungserinnerung': 'Payment reminder',
  '1. Mahnung': 'First reminder',
  '2. Mahnung': 'Final reminder',
  'Deutsch': 'German',
  'Englisch': 'English',
  'Text in die Zwischenablage kopiert.': 'Text copied to the clipboard.',
  'Kopieren nicht möglich, bitte den Text markieren und manuell kopieren.': 'Copying is not possible; please select the text and copy it manually.',
  'Mahnvorschläge': 'Dunning suggestions',
  'mindestens 7 Tage nach Fälligkeit': 'at least 7 days past due',
  'Betroffener Betrag': 'Amount affected',
  'offen aus diesen Rechnungen': 'outstanding on these invoices',
  'Keine Mahnvorschläge': 'No dunning suggestions',
  'Rechnungen erscheinen hier 7 Tage nach Fälligkeit.': 'Invoices appear here 7 days after their due date.',
  'Bisher': 'Previous',
  'Vorschlag': 'Suggestion',
  'keine': 'none',
  'ohne Vorgang': 'no case',
  'Vorschau': 'Preview',
  '{stufe} zu {nummer}': '{stufe} for {nummer}',
  'Text auf Englisch': 'Text in English',
  'Text auf Deutsch': 'Text in German',
  'Text kopieren': 'Copy text',
  'Schließen': 'Close',
  'Erstellt': 'Creating',
  'Mahnung erstellen': 'Create reminder',
  'Die Rechnung hat keinen Vorgang. Die Mahnung wird erstellt, aber nicht im Vorgangsverlauf protokolliert.': 'The invoice has no case. The reminder will be created but not logged in the case history.',
  'Betreff': 'Subject',
  'Text': 'Text',
  'Der Versand erfolgt später über den Service Hub. Bis dahin den Text kopieren und per E-Mail senden.': 'Sending via the Service Hub will follow later. Until then, copy the text and send it by email.',
  'Empfänger laut Stammdaten: {email}': 'Recipient according to master data: {email}',
  '{stufe} erstellt und im Vorgang protokolliert, Text kopiert.': '{stufe} created and logged in the case, text copied.',
  '{stufe} erstellt und im Vorgang protokolliert.': '{stufe} created and logged in the case.',
  '{stufe} erstellt, Text kopiert.': '{stufe} created, text copied.',
  '{stufe} erstellt.': '{stufe} created.',
  "An Angebot erinnern": "Follow up on quotation",
  "Zahlungserinnerung senden": "Send payment reminder",
  "{art} per Mail senden": "Send {art} by email",
  "PDF wird erzeugt …": "Creating PDF …",
  "PDF": "PDF",
  "Erinnern": "Follow up",
  "Erneut senden": "Send again",
  "Per Mail senden": "Send by email",
  "Gesendet am {datum} an {an}": "Sent on {datum} to {an}",
  "Nachricht": "Message",
  "und {n} weitere": "and {n} more",
  "Dieser Beleg wurde noch nicht an den Kunden gesendet.": "This document has not yet been sent to the customer.",
  "Gesendet, aber nicht im Vorgang protokolliert: {fehler}": "Sent, but not logged in the case: {fehler}",
  "{stufe} gesendet.": "{stufe} sent.",
  "Die XML-Datei ist nicht lesbar.": "The XML file cannot be read.",
  "In der CSV-Datei fehlt eine Kopfzeile mit Datum und Betrag.": "The CSV file has no header row with date and amount.",
  "Die Spalten für Datum und Betrag wurden nicht erkannt.": "The date and amount columns were not recognised.",
  "Zum Einlesen von Kontoauszügen ist das Recht „Zahlungen buchen und mahnen“ nötig.": "Importing bank statements requires the permission “Book payments and send reminders”.",
  "Kontoauszug einlesen": "Import bank statement",
  "CAMT.053 (XML) oder CSV aus dem Onlinebanking. Gelesen werden nur Zahlungseingänge; bereits eingelesene Buchungen erkennt Merkan und bucht sie nicht doppelt.": "CAMT.053 (XML) or CSV from online banking. Only incoming payments are read; Merkan recognises entries already imported and does not book them twice.",
  "Wird gelesen …": "Reading …",
  "Datei wählen": "Choose file",
  "Keine Zahlungseingänge in der Datei": "No incoming payments in the file",
  "Auftraggeber und Verwendungszweck": "Payer and reference",
  "Treffer": "Match",
  "Buchung auswählen": "Select entry",
  "ohne Namen": "no name",
  "gebucht": "booked",
  "Rechnung zuordnen": "Assign invoice",
  "nicht zuordnen": "do not assign",
  "keine passende offene Rechnung": "no matching open invoice",
  "Betrag höher als offen": "amount exceeds open balance",
  "Vorausgewählt sind Eingänge mit erkannter Rechnungsnummer oder genau passendem Betrag mit weiterem Merkmal.": "Preselected are payments with a recognised invoice number or an exact amount plus another match.",
  "{n} Zahlung buchen": "Book {n} payment",
  "{n} Zahlungen buchen": "Book {n} payments",
  "{n} Zahlung gebucht.": "{n} payment booked.",
  "{n} Zahlungen gebucht.": "{n} payments booked.",
  "Inland 19 %": "Domestic 19 %",
  "Inland 7 %": "Domestic 7 %",
  "Inland steuerfrei": "Domestic VAT exempt",
  "Innergemeinschaftliche Lieferung": "Intra-Community supply",
  "Seeschifffahrt": "Sea-going vessels",
  "DATEV-Einstellungen gespeichert.": "DATEV settings saved.",
  "Bitte zuerst Berater- und Mandantennummer eintragen.": "Please enter the consultant and client number first.",
  "Erlöskonto fehlt für: {liste}. Bitte in den Einstellungen ergänzen.": "Revenue account missing for: {liste}. Please add it in the settings.",
  "Im Zeitraum gibt es keine gebuchten Rechnungen oder Zahlungen.": "There are no posted invoices or payments in this period.",
  "Für die DATEV-Übergabe ist das Recht „DATEV-Übergabe auslösen“ nötig.": "The DATEV export requires the permission “Run DATEV export”.",
  "Enthält gebuchte Rechnungen und Gutschriften (je USt-Satz eine Buchung auf das Erlöskonto der Steuerart) und die Zahlungseingänge im Zeitraum, dazu die Debitoren als Stammdaten. Format DATEV EXTF 700 für den Import in DATEV Rechnungswesen.": "Contains posted invoices and credit notes (one posting per VAT rate to the revenue account of the tax type) and incoming payments in the period, plus the debtors as master data. DATEV EXTF 700 format for import into DATEV Rechnungswesen.",
  "Buchungsstapel herunterladen": "Download posting batch",
  "Einstellungen ausblenden": "Hide settings",
  "DATEV-Einstellungen": "DATEV settings",
  "Die Kontenvorschläge bitte vor dem ersten Export mit der Steuerberatung abstimmen. Die Zuordnung gilt ab dem nächsten Export.": "Please agree the suggested accounts with your tax advisor before the first export. The assignment applies from the next export.",
  "Kontenrahmen": "Chart of accounts",
  "Beraternummer": "Consultant number",
  "Mandantennummer": "Client number",
  "Wirtschaftsjahr beginnt im Monat": "Financial year starts in month",
  "Sachkontenlänge": "Account length",
  "Bankkonto": "Bank account",
  "Debitoren ab": "Debtors from",
  "Kundennummer K-10006 wird zu Debitor 10006": "Customer number K-10006 becomes debtor 10006",
  "Erzeugt": "Created",
  "Buchungen": "Postings",
  "Umsatz": "Turnover",
  "Buchungsstapel mit {n} Buchung erzeugt.": "Posting batch with {n} posting created.",
  "Buchungsstapel mit {n} Buchungen erzeugt.": "Posting batch with {n} postings created.",
  "Für eine gültige XRechnung fehlen: {liste}": "Missing for a valid XRechnung: {liste}",
  "Zahlungseingang bestätigen": "Confirm payment received",
  "E-Rechnung im Format XRechnung (CII)": "E-invoice in XRechnung format (CII)",
  "XRechnung": "XRechnung",
  "Kontoauszug der Bank einlesen und Zahlungen zuordnen": "Import bank statement and match payments",
  "Buchungsstapel und Debitoren für die Steuerberatung": "Posting batch and debtors for the tax advisor",
  "Kontoauszug": "Bank statement",
  "Firmenanschrift": "Company address",
  "USt-IdNr. oder Steuernummer der Firma": "Company VAT or tax number",
  "E-Mail der Firma": "Company email",
  "Telefon der Firma": "Company phone",
  "Kundenname": "Customer name",
  "Kundenanschrift": "Customer address",
  "E-Mail oder Leitweg-ID des Kunden": "Customer email or Leitweg-ID",
  "USt-IdNr. des Kunden (innergemeinschaftliche Lieferung)": "Customer VAT number (intra-Community supply)",
  "USt-IdNr. der Firma (innergemeinschaftliche Lieferung)": "Company VAT number (intra-Community supply)",
  "erfasst": "recorded",
  "geprüft": "checked",
  "freigegeben": "approved",
  "Wird hochgeladen …": "Uploading …",
  "{ki} liest die Rechnung …": "{ki} is reading the invoice …",
  "Fällig bis heute": "Due by today",
  "Zur Freigabe": "Awaiting approval",
  "erfasst oder geprüft": "recorded or checked",
  "Lieferant oder Rechnungsnummer": "Supplier or invoice number",
  "Filter": "Filter",
  "Offene": "Open",
  "Rechnung hochladen": "Upload invoice",
  "PDF, Scan, Foto (JPG, PNG) oder E-Rechnung (XRechnung, ZUGFeRD). Die KI liest Lieferant, Nummer, Beträge und Positionen; du prüfst und gibst frei. Rechnungen aus Mails lassen sich im Service Hub am Anhang auswerten.": "PDF, scan, photo (JPG, PNG) or e-invoice (XRechnung, ZUGFeRD). The AI reads supplier, number, amounts and lines; you check and approve. Invoices received by email can be read from the attachment in the Service Hub.",
  "Keine Eingangsrechnungen": "No supplier invoices",
  "Rechnungen von Lieferanten hier hochladen oder aus einer Mail übernehmen.": "Upload supplier invoices here or take them over from an email.",
  "Abweichung zur Bestellung": "Deviation from purchase order",
  "Netto {ist} statt {soll} laut Bestellung {nr}": "Net {ist} instead of {soll} as per purchase order {nr}",
  "Wareneingang für {n} Position offen": "Goods receipt open for {n} line",
  "Wareneingang für {n} Positionen offen": "Goods receipt open for {n} lines",
  "Bitte den Lieferanten angeben.": "Please enter the supplier.",
  "Diese Rechnung des Lieferanten ist bereits erfasst.": "This supplier invoice has already been recorded.",
  "Eingangsrechnung freigegeben.": "Supplier invoice approved.",
  "Als bezahlt gebucht.": "Posted as paid.",
  "Eingangsrechnung abgelehnt.": "Supplier invoice rejected.",
  "Eingangsrechnung gespeichert.": "Supplier invoice saved.",
  "Eingangsrechnung {nr}": "Supplier invoice {nr}",
  "Eingangsrechnung erfassen": "Record supplier invoice",
  "Von {ki} gelesen (KI, {s} % sicher). Bitte prüfen.": "Read by {ki} (AI, {s} % confidence). Please check.",
  "Geprüft": "Checked",
  "Als bezahlt buchen": "Post as paid",
  "{ki} konnte das Dokument nicht lesen. Bitte die Angaben von Hand erfassen.": "{ki} could not read the document. Please enter the details manually.",
  "Das Dokument sieht nicht wie eine Rechnung aus ({art}).": "The document does not look like an invoice ({art}).",
  "Nicht im Stamm: {name}": "Not in master data: {name}",
  "Name laut Rechnung": "Name as per invoice",
  "Zahlungsziel {n} Tage": "Payment term {n} days",
  "Netto und USt ergeben nicht den Bruttobetrag": "Net and VAT do not add up to the gross amount",
  "Skonto %": "Discount %",
  "Skonto bis": "Discount until",
  "Keine Bestellung": "No purchase order",
  "Kein Vorgang": "No case",
  "Vorgang öffnen": "Open case",
  "Abweichung:": "Deviation:",
  "Abweichung geprüft und akzeptiert": "Deviation checked and accepted",
  "Bezahlt am {datum}": "Paid on {datum}",
  "Datei öffnen": "Open file",
  "{ki} liest den Kontoauszug …": "{ki} is reading the bank statement …",
  "Von {ki} gelesen (KI, {s} % sicher). Beträge und Daten bitte mit dem Auszug vergleichen.": "Read by {ki} (AI, {s} % confidence). Please compare amounts and dates with the statement.",
  "Die Datei ist nicht verfügbar.": "The file is not available.",
  "Wird gebucht …": "Posting …",
  "CAMT.053 (XML) oder CSV aus dem Onlinebanking, oder der Auszug als PDF, Scan oder Foto (liest {ki}). Eingänge werden Ausgangsrechnungen zugeordnet, Ausgänge offenen Eingangsrechnungen. Bereits eingelesene Buchungen erkennt Merkan und bucht sie nicht doppelt.": "CAMT.053 (XML) or CSV from online banking, or the statement as PDF, scan or photo (read by {ki}). Incoming payments are matched to sales invoices, outgoing payments to open purchase invoices. Merkan recognises transactions already imported and does not book them twice.",
  "Keine Buchungen in der Datei": "No entries in the file",
  "Auftraggeber oder Empfänger und Verwendungszweck": "Payer or payee and reference",
  "ER": "SI",
  "keine passende Eingangsrechnung": "no matching supplier invoice",
  "Vorausgewählt sind Buchungen mit erkannter Rechnungsnummer oder genau passendem Betrag mit weiterem Merkmal. Ausgänge setzen die Eingangsrechnung auf bezahlt.": "Preselected are entries with a recognised invoice number or an exactly matching amount plus another feature. Outgoing payments mark the supplier invoice as paid.",
  "{n} Buchung übernehmen": "Apply {n} entry",
  "{n} Buchungen übernehmen": "Apply {n} entries",
  "{n} Zahlungseingang gebucht": "{n} incoming payment posted",
  "{n} Zahlungseingänge gebucht": "{n} incoming payments posted",
  "{n} Eingangsrechnung bezahlt": "{n} supplier invoice paid",
  "{n} Eingangsrechnungen bezahlt": "{n} supplier invoices paid",
  "{n} Eingang": "{n} incoming",
  "{n} Eingänge": "{n} incoming",
  "{n} Ausgang": "{n} outgoing",
  "{n} Ausgänge": "{n} outgoing",
  "Betrag mit Skonto": "Amount with discount",
  "Rechnungen von Lieferanten erfassen, prüfen, freigeben und bezahlen": "Record, check, approve and pay supplier invoices",
  "Eingangsrechnungen": "Supplier invoices",
  "Rechnung, Angebot oder Kontoauszug mit {ki} auslesen": "Read invoice, quotation or bank statement with {ki}",
  "Liest …": "Reading …",
  "Auswerten": "Read",
  "Aussteller unbekannt": "Issuer unknown",
  "Als Eingangsrechnung erfassen": "Record as supplier invoice",
  "Als Lieferantenangebot in den Vorgang": "Add to case as supplier quotation",
  "Kontoauszug zuordnen": "Match bank statement",
  "Die Nachricht erst einem Vorgang zuordnen, dann das Angebot übernehmen.": "Assign the message to a case first, then take over the quotation.",
  "Für diese Dokumentart gibt es keinen Folgeschritt.": "There is no follow-up step for this document type.",
  "{n} Buchung": "{n} entry",
  "{n} Buchungen": "{n} entries",
  "Stammartikel {nr}": "Master item {nr}",
  "Lieferant „{name}“ ist nicht im Stamm, bitte wählen.": "Supplier “{name}” is not in master data, please select.",
  "Lieferant nicht erkannt, bitte wählen.": "Supplier not recognised, please select.",
  "Preise in {w}": "Prices in {w}",
  "Gültig bis {datum}": "Valid until {datum}",
  "Lieferantenangebot übernehmen": "Take over supplier quotation",
  "Aus {datei} gelesen. Zuordnung und Preise bitte prüfen.": "Read from {datei}. Please check matching and prices.",
  "Angebot als PDF oder Foto hochladen oder Text einfügen; Zeilen werden den Positionen zugeordnet": "Upload the quotation as PDF or photo or paste the text; lines are matched to the case lines",
  "{ki} liest das Angebot …": "{ki} is reading the quotation …",
  "PDF oder Foto auslesen": "Read PDF or photo",
  "oder den Text unten einfügen": "or paste the text below",
  "Die Datei ist größer als 20 MB.": "The file is larger than 20 MB.",
  "Das Dokument konnte nicht ausgelesen werden.": "The document could not be read.",
  "Sonstiges Dokument": "Other document",
  "Dokumenterkennung": "Document recognition",
  "PDF, Scan, Foto (JPG, PNG) oder E-Rechnung (XRechnung, ZUGFeRD); bei mehrseitigen Rechnungen alle Fotos zusammen auswählen. {ki} liest Lieferant, Nummer, Beträge und Positionen; du prüfst und gibst frei. Rechnungen aus Mails lassen sich im Service Hub am Anhang auswerten.": "PDF, scan, photo (JPG, PNG) or e-invoice (XRechnung, ZUGFeRD); for multi-page invoices select all photos together. {ki} reads supplier, number, amounts and items; you check and approve. Invoices from emails can be read from the attachment in the Service Hub.",
  "Mehrere Dateien nur als Fotos (JPG, PNG) einer Rechnung; ein PDF bitte einzeln hochladen.": "Multiple files only as photos (JPG, PNG) of one document; please upload a PDF on its own.",
  "Höchstens 10 Seiten auf einmal.": "At most 10 pages at once.",
  "Summe aus {n} Position": "Total of {n} line",
  "Summe aus {n} Positionen": "Total of {n} lines",
  "weicht vom Netto ab": "differs from net",
  "Betrag weicht vom Rechnungsbetrag ab, bitte prüfen": "Amount differs from invoice amount, please check",
  "Zu zahlen": "Amount due",
  "Weicht vom Brutto ab, z. B. nach Abzug von Abschlägen": "Differs from gross, e.g. after deducting progress payments",
  "Gutschrift des Lieferanten: Beträge sind negativ und mindern die offenen Verbindlichkeiten.": "Supplier credit note: amounts are negative and reduce open payables.",
  "Gutschrift {nr}": "Credit note {nr}",
  "Rechnung in {w}: Beträge stehen in Fremdwährung. Für Zahlung und Buchhaltung den Euro-Betrag am Zahltag beachten.": "Invoice in {w}: amounts are in foreign currency. For payment and accounting use the euro amount on the payment date.",
  "Debitoren": "Receivables",
  "So heißen in der Buchhaltung deine Kunden, also alle, die dir Geld schulden. Hier findest du deine Rechnungen an Kunden, was davon noch offen ist, eingegangene Zahlungen und Mahnungen.": "Accounting term for your customers, everyone who owes you money. Here you find your invoices to customers, what is still open, payments received and dunning.",
  "Du schickst einem Kunden eine Rechnung über 5.000 €. Bis er bezahlt, ist der Kunde dein Debitor mit einem offenen Posten von 5.000 €.": "You send a customer an invoice for €5,000. Until they pay, the customer is your debtor with an open item of €5,000.",
  "Was sind Debitoren und was mache ich unter Debitoren in Merkan?": "What are receivables (debtors) and what do I do under Receivables in Merkan?",
  "Kreditoren": "Payables",
  "So heißen in der Buchhaltung deine Lieferanten und Dienstleister, also alle, denen du Geld schuldest. Hier erfasst, prüfst, gibst frei und bezahlst du ihre Rechnungen.": "Accounting term for your suppliers and service providers, everyone you owe money to. Here you capture, check, approve and pay their invoices.",
  "Ein Lieferant schickt dir eine Rechnung über 1.200 €, zahlbar in 30 Tagen. Bis du bezahlst, ist er dein Kreditor mit einem offenen Posten von 1.200 €.": "A supplier sends you an invoice for €1,200, payable in 30 days. Until you pay, the supplier is your creditor with an open item of €1,200.",
  "Was sind Kreditoren und was mache ich unter Kreditoren in Merkan?": "What are payables (creditors) and what do I do under Payables in Merkan?",
  "Bank und Abschluss": "Bank and closing",
  "Hier liest du den Kontoauszug ein. Merkan ordnet jede Buchung der passenden Rechnung zu: Eingänge den Kundenrechnungen, Ausgänge den Lieferantenrechnungen. Am Monatsende gibst du die Buchungen per DATEV an die Steuerberatung.": "Import your bank statement here. Merkan matches every transaction to the right invoice: incoming payments to customer invoices, outgoing payments to supplier invoices. At month end you send the bookings to your tax adviser via DATEV.",
  "Wie arbeite ich mit Kontoauszug und DATEV in Merkan?": "How do I work with bank statements and DATEV in Merkan?",
  "Rechnungen, die noch nicht oder nur teilweise bezahlt sind. Bei Debitoren ist das Geld, das du bekommst, bei Kreditoren Geld, das du zahlen musst.": "Invoices that are unpaid or only partly paid. For receivables it is money you will receive, for payables money you have to pay.",
  "Was sind offene Posten?": "What are open items?",
  "Offene Posten der Lieferanten": "Open supplier items",
  "Alle Lieferantenrechnungen, die du noch bezahlen musst, sortiert nach Fälligkeit. Mit Skonto zahlst du weniger, wenn du innerhalb der Skontofrist bezahlst.": "All supplier invoices you still have to pay, sorted by due date. With an early payment discount you pay less if you pay within the discount period.",
  "Welche Lieferantenrechnungen sollte ich zuerst bezahlen?": "Which supplier invoices should I pay first?",
  "Ausgleich": "Clearing",
  "Eine Zahlung wird mit der passenden Rechnung verrechnet. Ist der volle Betrag bezahlt, ist der offene Posten ausgeglichen; bei einer Teilzahlung bleibt der Rest offen.": "A payment is offset against the matching invoice. If the full amount is paid the open item is cleared; with a partial payment the rest stays open.",
  "Was bedeutet Ausgleich eines offenen Postens?": "What does clearing an open item mean?",
  "Zahlungsvorschlag": "Payment proposal",
  "Merkan schlägt vor, welche Lieferantenrechnungen jetzt bezahlt werden sollten, zuerst die mit ablaufender Skontofrist. Daraus entsteht eine Überweisungsdatei für die Bank. In SAP heißt das Zahllauf.": "Merkan proposes which supplier invoices should be paid now, those with an expiring discount first. This creates a transfer file for the bank. In SAP this is called a payment run.",
  "Wie funktioniert ein Zahlungsvorschlag?": "How does a payment proposal work?",
  "Erinnert Kunden an überfällige Rechnungen, erst freundlich, dann als Mahnung. Merkan schlägt vor, wer wann gemahnt werden sollte; du entscheidest.": "Reminds customers of overdue invoices, first politely, then as a dunning letter. Merkan proposes who should be reminded when; you decide.",
  "Wie funktioniert das Mahnwesen in Merkan?": "How does dunning work in Merkan?",
  "Ausgangsrechnung": "Sales invoice",
  "Eine Rechnung, die du an einen Kunden schickst. In SAP heißt sie Faktura.": "An invoice you send to a customer. In SAP it is called a billing document.",
  "Was ist eine Ausgangsrechnung?": "What is a sales invoice?",
  "Eingangsrechnung": "Purchase invoice",
  "Eine Rechnung, die du von einem Lieferanten oder Dienstleister bekommst. Sie wird geprüft, freigegeben und dann bezahlt.": "An invoice you receive from a supplier or service provider. It is checked, approved and then paid.",
  "Wie bearbeite ich eine Eingangsrechnung?": "How do I process a purchase invoice?",
  "Das Gegenteil einer Rechnung: Der Betrag wird abgezogen statt gefordert, zum Beispiel bei einer Rücksendung oder einem Preisnachlass.": "The opposite of an invoice: the amount is deducted instead of charged, for example for a return or a price reduction.",
  "Wann brauche ich eine Gutschrift?": "When do I need a credit note?",
  "Forderung": "Receivable",
  "Geld, das dir ein Kunde schuldet. Jede offene Ausgangsrechnung ist eine Forderung.": "Money a customer owes you. Every open sales invoice is a receivable.",
  "Was ist eine Forderung?": "What is a receivable?",
  "Verbindlichkeit": "Payable",
  "Geld, das du einem Lieferanten schuldest. Jede offene Eingangsrechnung ist eine Verbindlichkeit.": "Money you owe a supplier. Every open purchase invoice is a payable.",
  "Was ist eine Verbindlichkeit?": "What is a payable?",
  "Skonto": "Early payment discount",
  "Ein Preisnachlass für schnelle Zahlung, zum Beispiel 2 % bei Zahlung innerhalb von 10 Tagen. Skonto lohnt sich fast immer.": "A discount for paying quickly, for example 2 % if paid within 10 days. It is almost always worth it.",
  "Rechnung 10.000 €, 2 % Skonto in 10 Tagen: Wer rechtzeitig zahlt, überweist 9.800 € und spart 200 €.": "Invoice €10,000, 2 % discount within 10 days: paying on time means transferring €9,800 and saving €200.",
  "Lohnt sich Skonto und wie berechne ich es?": "Is an early payment discount worth it and how do I calculate it?",
  "Zahlungssperre": "Payment block",
  "Eine Rechnung darf nicht bezahlt werden, bis eine Abweichung geklärt ist, etwa ein höherer Preis als bestellt oder mehr berechnet als geliefert.": "An invoice must not be paid until a difference is resolved, for example a higher price than ordered or more charged than delivered.",
  "Warum ist eine Rechnung zur Zahlung gesperrt?": "Why is an invoice blocked for payment?",
  "Drei-Wege-Abgleich": "Three-way match",
  "Die Lieferantenrechnung wird mit zwei anderen Belegen verglichen: mit der Bestellung (stimmt der Preis?) und mit dem Wareneingang (wurde die berechnete Menge auch geliefert?). Passt alles, kann die Rechnung freigegeben werden.": "The supplier invoice is compared with two other documents: the purchase order (is the price right?) and the goods receipt (was the invoiced quantity delivered?). If everything matches, the invoice can be approved.",
  "Was ist der Drei-Wege-Abgleich bei Eingangsrechnungen?": "What is the three-way match for purchase invoices?",
  "Die Ware eines Lieferanten ist angekommen und wird mit dem Lieferschein gegen die Bestellung gebucht. Erst dann weiß Merkan, was tatsächlich geliefert wurde.": "A supplier's goods have arrived and are booked against the purchase order using the delivery note. Only then does Merkan know what was actually delivered.",
  "Wie buche ich einen Wareneingang?": "How do I book a goods receipt?",
  "Auslieferung": "Outbound delivery",
  "Die Ware geht an deinen Kunden. Dazu gehört der Lieferschein für den Kunden, den Merkan im Vorgang erzeugt.": "The goods go to your customer, together with the customer delivery note that Merkan creates in the case.",
  "Wie erstelle ich einen Lieferschein für den Kunden?": "How do I create a delivery note for the customer?",
  "Belegfluss": "Document flow",
  "Alle Belege eines Vorgangs in ihrer Reihenfolge: links was mit dem Kunden passiert (Angebot, Auftrag, Lieferung, Rechnung, Zahlung), rechts was mit dem Lieferanten passiert (Bestellung, Wareneingang, Eingangsrechnung, Zahlung). So siehst du auf einen Blick, was erledigt ist und was fehlt.": "All documents of a case in order: on the left what happens with the customer (quotation, order, delivery, invoice, payment), on the right with the supplier (purchase order, goods receipt, purchase invoice, payment). You see at a glance what is done and what is missing.",
  "Was zeigt der Belegfluss in einem Vorgang?": "What does the document flow of a case show?",
  "Bestätigt einen Auftrag verbindlich, mit Preisen und Lieferterminen. Du schickst sie an den Kunden; dein Lieferant schickt dir seine zu deiner Bestellung.": "Confirms an order with prices and delivery dates. You send one to the customer; your supplier sends you one for your purchase order.",
  "Was gehört in eine Auftragsbestätigung?": "What belongs in an order confirmation?",
  "Dein Auftrag an einen Lieferanten. Sie ist die Grundlage für den Wareneingang und die Prüfung seiner Rechnung.": "Your order to a supplier. It is the basis for the goods receipt and for checking the supplier's invoice.",
  "Wie bestelle ich beim Lieferanten?": "How do I order from a supplier?",
  "Die Buchungen deines Bankkontos. Merkan liest ihn als Datei aus dem Onlinebanking oder als PDF und Foto ein und ordnet die Zahlungen den Rechnungen zu.": "The transactions of your bank account. Merkan imports it as a file from online banking or as PDF and photo and matches payments to invoices.",
  "Wie lese ich einen Kontoauszug ein?": "How do I import a bank statement?",
  "DATEV": "DATEV",
  "Das Programm der meisten Steuerberatungen in Deutschland. Merkan erzeugt die Dateien, die deine Steuerberatung dort einliest.": "The software used by most tax advisers in Germany. Merkan creates the files your tax adviser imports there.",
  "Was muss ich der Steuerberatung per DATEV schicken?": "What do I need to send my tax adviser via DATEV?",
  "Was ist das?": "What is this?",
  "Als Gutschrift des Lieferanten erfassen": "Capture as supplier credit note",
  "Als Lieferantenangebot im Vorgang erfassen": "Capture as supplier quotation in the case",
  "Als Auftragsbestätigung im Vorgang erfassen": "Capture as order confirmation in the case",
  "Als Lieferschein buchen (Wareneingang)": "Book as delivery note (goods receipt)",
  "Als Kontoauszug einlesen": "Import as bank statement",
  "{ki} hat hier eine andere Belegart erkannt: {art}.": "{ki} recognised a different document type here: {art}.",
  "Lieferantenangebote und Auftragsbestätigungen gehören in einen Vorgang: dort im Belegfluss einlesen.": "Supplier quotations and order confirmations belong to a case: import them there in the document flow.",
  "Für diese Belegart gibt es hier keine passende Funktion oder dir fehlt die Berechtigung.": "There is no matching function for this document type here or you lack the permission.",
  "Rechnungen, Gutschriften und weitere Belege an Kunden": "Invoices, credit notes and other documents to customers",
  "Was Kunden dir noch schulden, mit Fälligkeit": "What customers still owe you, with due dates",
  "Zahlungen von Kunden zu deinen Rechnungen": "Customer payments for your invoices",
  "Zahlungseingänge": "Payments received",
  "Wie funktioniert das Mahnwesen?": "How does dunning work?",
  "Was sind Debitoren?": "What are receivables?",
  "Was du Lieferanten noch zahlen musst, nach Fälligkeit und Skonto": "What you still have to pay suppliers, by due date and discount",
  "Was zuerst bezahlen?": "What to pay first?",
  "Rechnungen von Lieferanten und Dienstleistern erfassen, prüfen, freigeben und bezahlen": "Capture, check, approve and pay invoices from suppliers and service providers",
  "Was sind Kreditoren?": "What are payables?",
  "Buchungen und Debitoren für die Steuerberatung": "Bookings and debtors for your tax adviser",
  "Was ist DATEV?": "What is DATEV?",
  "Kontoauszug einlesen und Zahlungen den Rechnungen zuordnen": "Import bank statements and match payments to invoices",
  "Wie funktioniert das?": "How does it work?",
  "Keine Berechtigung": "No permission",
  "Für Kontoauszug und DATEV fehlt dir die Berechtigung.": "You do not have permission for bank statements and DATEV.",
  "Fällig in 7 Tagen": "Due in 7 days",
  "Skonto noch möglich": "Discount still available",
  "Ersparnis bei {n} Rechnung": "Saving on {n} invoice",
  "Ersparnis bei {n} Rechnungen": "Saving on {n} invoices",
  "Keine offenen Lieferantenrechnungen": "No open supplier invoices",
  "Alles bezahlt. Neue Rechnungen erfasst du unter Eingangsrechnungen.": "All paid. Capture new invoices under Purchase invoices.",
  "Gesperrt: Abweichung zur Bestellung": "Blocked: difference to purchase order",
  "{p} % spart {betrag}": "{p} % saves {betrag}",
  "Je Lieferant": "Per supplier",
  "Nächste Fälligkeit": "Next due date",
  "festgeschrieben": "finalised",
  "versendet": "sent",
  "bestellt": "ordered",
  "geliefert": "delivered",
  "noch kein Angebot": "no quotation yet",
  "noch nicht bestätigt": "not confirmed yet",
  "zugestellt": "delivered",
  "geplant": "planned",
  "noch nicht geliefert": "not delivered yet",
  "noch nicht berechnet": "not invoiced yet",
  "Zahlungseingang": "Payment received",
  "zu Rechnung": "for invoice",
  "noch keine Zahlung": "no payment yet",
  "AB {nr} vom {datum}": "Confirmation {nr} of {datum}",
  "AB fehlt": "Confirmation missing",
  "Liefertermin {datum}": "Delivery date {datum}",
  "noch nicht bestellt": "not ordered yet",
  "ohne Nummer": "without number",
  "Lieferschein von {name}": "Delivery note from {name}",
  "noch keine Ware eingegangen": "no goods received yet",
  "noch keine Rechnung des Lieferanten": "no supplier invoice yet",
  "Zahlungsausgang": "Payment made",
  "an {name}": "to {name}",
  "noch nicht bezahlt": "not paid yet",
  "Alle Belege dieses Vorgangs in ihrer Reihenfolge.": "All documents of this case in order.",
  "Was zeigt der Belegfluss?": "What does the document flow show?",
  "{ki} liest den Beleg …": "{ki} is reading the document …",
  "Beleg zum Vorgang einlesen": "Import document for this case",
  "Lieferantenrechnung, Lieferschein, Lieferantenangebot oder Auftragsbestätigung als PDF oder Foto: {ki} erkennt die Art und öffnet die passende Funktion mit Bezug zu diesem Vorgang.": "Supplier invoice, delivery note, supplier quotation or order confirmation as PDF or photo: {ki} recognises the type and opens the matching function linked to this case.",
  "Mit dem Kunden": "With the customer",
  "Mit dem Lieferanten": "With the supplier",
  "Welche Lieferantenrechnungen sind diese Woche fällig?": "Which supplier invoices are due this week?",
  "Wo kann ich noch Skonto nutzen?": "Where can I still use an early payment discount?",
  "Welche Buchungen sind noch nicht zugeordnet?": "Which transactions are not matched yet?",
  "Was muss ich der Steuerberatung schicken?": "What do I need to send my tax adviser?",
  "Eine Rechnung darf nicht freigegeben und bezahlt werden, bis eine Abweichung geklärt ist. Merkan setzt sie automatisch: Preis höher als bestellt, mehr berechnet als geliefert, Artikel nicht bestellt, oder eine IBAN, die nicht zum Lieferantenstamm passt (häufigster Trick bei Rechnungsbetrug).": "An invoice must not be approved or paid until a difference is resolved. Merkan sets it automatically: price higher than ordered, more invoiced than delivered, items not ordered, or an IBAN that does not match the supplier master (the most common invoice fraud trick).",
  "bereits in einem Zahllauf": "already in a payment run",
  "Gutschrift: beim nächsten Zahlungsausgleich mit dem Lieferanten verrechnen": "Credit note: offset with the supplier at the next payment",
  "Zahlungssperre: Abweichung erst prüfen": "Payment block: check the difference first",
  "noch nicht freigegeben": "not approved yet",
  "keine Euro-Rechnung, SEPA nur in Euro": "not in euros, SEPA is euro only",
  "IBAN fehlt oder ist ungültig": "IBAN missing or invalid",
  "SEPA-Datei erzeugen?": "Create SEPA file?",
  "{n} Überweisungen über {summe} zum {datum} vom Konto {iban}. Die Rechnungen werden für weitere Zahlläufe gesperrt, bis der Kontoauszug die Zahlung zeigt oder du den Zahllauf stornierst.": "{n} transfers totalling {summe} on {datum} from account {iban}. The invoices are locked for further payment runs until the bank statement shows the payment or you cancel the run.",
  "Datei erzeugen": "Create file",
  "Zahllauf stornieren?": "Cancel payment run?",
  "Nur stornieren, wenn die Datei nicht im Onlinebanking ausgeführt wurde. Die noch nicht bezahlten Rechnungen werden wieder für den Zahlungsvorschlag frei.": "Only cancel if the file was not executed in online banking. Unpaid invoices become available for the payment proposal again.",
  "Zahllauf storniert.": "Payment run cancelled.",
  "Für den Zahlungsvorschlag ist das Recht „Zahlungen buchen und mahnen“ nötig.": "The payment proposal requires the permission to book payments and dun.",
  "Für die SEPA-Datei fehlt eine gültige IBAN eures Kontos.": "A valid IBAN of your own account is missing for the SEPA file.",
  "In den Firmendaten eintragen": "Enter it in the company details",
  "Ausführung am": "Execution date",
  "Fällige bis": "Due up to",
  "Ausführungstag": "Execution date",
  "7 Tage danach": "7 days later",
  "14 Tage danach": "14 days later",
  "30 Tage danach": "30 days later",
  "SEPA-Datei erzeugen": "Create SEPA file",
  "Vorgeschlagen sind Rechnungen, deren Skontofrist am Ausführungstag noch läuft, und alle, die bis zur gewählten Grenze fällig sind. Die Datei lädst du im Onlinebanking als SEPA-Sammelüberweisung hoch und gibst sie dort mit TAN frei. Bezahlt wird jede Rechnung, sobald der Kontoauszug die Abbuchung zeigt.": "Proposed are invoices whose discount period is still running on the execution date and all invoices due by the chosen limit. Upload the file in online banking as a SEPA batch transfer and authorise it with a TAN. Each invoice is marked paid as soon as the bank statement shows the debit.",
  "Keine zahlbereiten Rechnungen": "No invoices ready for payment",
  "Zahlbar sind freigegebene Euro-Rechnungen ohne Zahlungssperre und mit gültiger IBAN. Die übrigen offenen Rechnungen stehen unten mit Grund.": "Payable are approved euro invoices without a payment block and with a valid IBAN. The other open invoices are listed below with the reason.",
  "Alle auswählen": "Select all",
  "Rechnung {nr} auswählen": "Select invoice {nr}",
  "statt {betrag}": "instead of {betrag}",
  "Nicht im Vorschlag": "Not in the proposal",
  "Freigeben und Zahlungssperren klären unter Eingangsrechnungen.": "Approve invoices and resolve payment blocks under Purchase invoices.",
  "Zu den Eingangsrechnungen": "Go to purchase invoices",
  "Zahlläufe": "Payment runs",
  "Ausführung": "Execution",
  "Überweisungen": "Transfers",
  "{b} von {n} bezahlt": "{b} of {n} paid",
  "Datei": "File",
  "Fällige und skontofähige Rechnungen bezahlen: Auswahl prüfen, SEPA-Datei erzeugen, im Onlinebanking hochladen": "Pay due and discountable invoices: check the selection, create the SEPA file, upload it in online banking",
  "Was ist ein Zahlungsvorschlag?": "What is a payment proposal?",
  "{n} Überweisung": "{n} transfer",
  "{n} Überweisungen": "{n} transfers",
  "Zahllauf mit {n} Überweisung erzeugt. Datei jetzt im Onlinebanking hochladen.": "Payment run with {n} transfer created. Now upload the file in online banking.",
  "Zahllauf mit {n} Überweisungen erzeugt. Datei jetzt im Onlinebanking hochladen.": "Payment run with {n} transfers created. Now upload the file in online banking.",
  "Gutschrift: wird verrechnet, sobald eine Rechnung dieses Lieferanten zur Zahlung ansteht": "Credit note: will be offset as soon as an invoice from this supplier is due for payment",
  "Gutschrift von {name} ohne Rechnung im Zahllauf. Eine Rechnung dazu wählen oder die Gutschrift abwählen.": "Credit note from {name} without an invoice in the payment run. Select an invoice or deselect the credit note.",
  "Bei {name} übersteigen die Gutschriften die Rechnungen. Eine Gutschrift abwählen.": "For {name} the credit notes exceed the invoices. Deselect a credit note.",
  "Die Rechnungen von {name} haben verschiedene IBANs. Mit Gutschrift ist nur eine Überweisung an eine IBAN möglich.": "The invoices from {name} have different IBANs. With a credit note only one transfer to one IBAN is possible.",
  "Zahllauf als ausgeführt bestätigen?": "Confirm payment run as executed?",
  "Bestätige das erst, wenn die Bank die Sammelüberweisung ausgeführt hat. Alle Rechnungen des Zahllaufs gelten dann zum {datum} als bezahlt, Gutschriften als verrechnet.": "Only confirm once the bank has executed the bulk transfer. All invoices in the run are then considered paid as of {datum}, credit notes as offset.",
  "Als ausgeführt bestätigen": "Confirm as executed",
  "Am {datum} ({grund}) führen Banken keine SEPA-Zahlungen aus.": "Banks do not execute SEPA payments on {datum} ({grund}).",
  "Auf {datum} verschieben": "Move to {datum}",
  "Vorgeschlagen sind Rechnungen, deren Skontofrist am Ausführungstag noch läuft, und alle, die bis zur gewählten Grenze fällig sind. Gutschriften desselben Lieferanten werden abgezogen, dann geht eine Überweisung über den Rest. Die Datei lädst du im Onlinebanking als SEPA-Sammelüberweisung hoch und gibst sie dort mit TAN frei. Danach bestätigst du den Zahllauf als ausgeführt oder liest den Kontoauszug ein.": "Proposed are invoices whose discount period is still running on the execution date and all invoices due by the selected limit. Credit notes from the same supplier are deducted and one transfer covers the rest. Upload the file in online banking as a SEPA bulk transfer and authorise it with a TAN. Afterwards confirm the run as executed or import the bank statement.",
  "wird abgezogen": "deducted",
  "ausgeführt": "executed",
  "Datei erzeugt": "File created",
  "Ausgeführt": "Executed",
  "Sonntag": "Sunday",
  "Samstag": "Saturday",
  "Neujahr": "New Year's Day",
  "Karfreitag": "Good Friday",
  "Ostermontag": "Easter Monday",
  "Tag der Arbeit": "Labour Day",
  "1. Weihnachtstag": "Christmas Day",
  "2. Weihnachtstag": "Boxing Day",
  "Zahllauf-Kennung": "Payment run ID",
  "{n} Beleg als bezahlt gebucht.": "{n} document posted as paid.",
  "{n} Belege als bezahlt gebucht.": "{n} documents posted as paid.",
  // Fachlicher Belegstatus je Belegart und Abschluss eines Entwurfs
  "Ausgestellt oder gebucht": "Issued or posted",
  "In Bearbeitung, noch ohne Nummer und jederzeit änderbar.": "Being edited, no number yet, can be changed at any time.",
  "Zurückgezogen": "Withdrawn",
  "Das Angebot wurde zurückgezogen und gilt nicht mehr.": "The quotation has been withdrawn and is no longer valid.",
  "Ungültig gemacht. Der Beleg bleibt zur Nachvollziehbarkeit unverändert erhalten.": "Voided. The document is kept unchanged for traceability.",
  "Der Kunde hat beauftragt, es gibt eine Auftragsbestätigung.": "The customer has placed the order; an order confirmation exists.",
  "Nicht beauftragt": "Not ordered",
  "Der Vorgang ist abgeschlossen, ohne dass dieses Angebot beauftragt wurde.": "The case is closed without this quotation being ordered.",
  "Abgelaufen": "Expired",
  "Die Gültigkeit des Angebots ist überschritten.": "The quotation is past its validity date.",
  "Versendet": "Sent",
  "An den Kunden gesendet, die Antwort steht aus.": "Sent to the customer, awaiting a reply.",
  "Ausgestellt": "Issued",
  "Mit Nummer ausgestellt und nicht mehr änderbar, aber noch nicht versendet.": "Issued with a number and locked, but not sent yet.",
  "Zu diesem Auftrag ist die Rechnung gestellt.": "The invoice for this order has been issued.",
  "Bestätigt": "Confirmed",
  "Auftrag bestätigt und nicht mehr änderbar. Die Rechnung steht noch aus.": "Order confirmed and locked. The invoice is still to follow.",
  "Ausgeliefert": "Delivered",
  "Die Ware ist mit diesem Lieferschein an den Kunden gegangen.": "The goods have gone to the customer with this delivery note.",
  "Ausgeglichen": "Settled",
  "Die Gutschrift ist ausgezahlt oder verrechnet.": "The credit note has been paid out or offset.",
  "Gebucht": "Posted",
  "In der Buchhaltung gebucht und nach GoBD nicht mehr änderbar.": "Posted in the accounts and locked as required by GoBD.",
  "Die Rechnung ist vollständig bezahlt.": "The invoice has been paid in full.",
  "Teilbezahlt, überfällig": "Partly paid, overdue",
  "Ein Teil ist bezahlt, der Rest ist seit dem Fälligkeitsdatum offen.": "Partly paid; the remainder is open past the due date.",
  "Teilbezahlt": "Partly paid",
  "Ein Teil ist bezahlt, der Rest ist noch offen.": "Partly paid; the remainder is still open.",
  "Gebucht, aber nach dem Fälligkeitsdatum noch nicht bezahlt.": "Posted but not paid by the due date.",
  "Gebucht (offen)": "Posted (open)",
  "In der Buchhaltung gebucht und nach GoBD nicht mehr änderbar. Die Zahlung steht aus.": "Posted in the accounts and locked as required by GoBD. Payment is outstanding.",
  "Ausstellen": "Issue",
  "Angebot ausstellen?": "Issue quotation?",
  "Angebot {nummer} ausgestellt.": "Quotation {nummer} issued.",
  "Auftrag bestätigen": "Confirm order",
  "Auftrag bestätigen?": "Confirm order?",
  "Auftragsbestätigung {nummer} erstellt.": "Order confirmation {nummer} created.",
  "Lieferschein ausstellen?": "Issue delivery note?",
  "Lieferschein {nummer} ausgestellt.": "Delivery note {nummer} issued.",
  "Gutschrift buchen?": "Post credit note?",
  "Gutschrift {nummer} gebucht.": "Credit note {nummer} posted.",
  "Rechnung buchen?": "Post invoice?",
  "Rechnung {nummer} gebucht.": "Invoice {nummer} posted.",
  "Rechnung erzeugt und gebucht.": "Invoice created and posted.",
  "Buchen, nicht versenden": "Post, do not send",
  "Buchen und versenden": "Post and send",
  "Nur Entwurf": "Draft only",
  // Auswahl und Status ändern
  "Abgelehnt": "Declined",
  "Der Kunde hat das Angebot abgelehnt.": "The customer has declined the quotation.",
  "Gemahnt": "Reminder sent",
  "Zahlungserinnerung oder Mahnung ist versandt, die Zahlung steht aus.": "A payment reminder or dunning letter has been sent; payment is outstanding.",
  "Automatisch ermitteln": "Determine automatically",
  "Lieferschein ausgestellt, die Auslieferung ist noch nicht bestätigt.": "Delivery note issued; delivery not yet confirmed.",
  "Status von {n} Beleg geändert.": "Status of {n} document changed.",
  "Status von {n} Belegen geändert.": "Status of {n} documents changed.",
  "Status ändern": "Change status",
  "Status setzen": "Set status",
  "Neuer Status": "New status",
  "Belegarten, für die dieser Status nicht gilt, werden übersprungen.": "Document types this status does not apply to are skipped.",
  "Inhalt und Beträge der Belege bleiben unverändert. Die Änderung steht im Verlauf des Vorgangs.": "Content and amounts of the documents remain unchanged. The change is recorded in the case history.",
  "Status geändert.": "Status changed.",
  "Im Portal veröffentlichen": "Publish in portal",
  "Aus dem Portal zurückziehen": "Withdraw from portal",
  "Auswahl aufheben": "Clear selection",
  "Als ZIP herunterladen": "Download as ZIP",
  "{n} Beleg gewählt": "{n} document selected",
  "{n} Belege gewählt": "{n} documents selected",
  "Auswahl": "Selection",
  "Alle wählen": "Select all",
  "{nummer} wählen": "Select {nummer}",
  "Belege senden": "Send documents",
  "Im Kundenportal veröffentlichen": "Publish in customer portal",
  "Senden und veröffentlichen": "Send and publish",
  "Zurückziehen": "Withdraw",
  "Veröffentlichen": "Publish",
  "Jetzt senden": "Send now",
  "Vorgehen": "Action",
  "Nur per Mail senden": "Send by email only",
  "Nur im Kundenportal veröffentlichen": "Publish in customer portal only",
  "Senden und im Portal veröffentlichen": "Send and publish in portal",
  "Leer: erstes aktives Sammelpostfach": "Empty: first active shared mailbox",
  "Automatisch": "Automatic",
  "Ohne Rechnungsadresse beim Kunden, wird nicht gesendet: {liste}": "No billing email for the customer, will not be sent: {liste}",
  "Entwürfe und stornierte Belege werden übersprungen.": "Drafts and cancelled documents are skipped.",
  "Die Belege verschwinden aus dem Kundenportal. Bereits heruntergeladene Dateien bleiben beim Kunden.": "The documents are removed from the customer portal. Files already downloaded remain with the customer.",
  "Jeder Beleg wird als PDF erzeugt und archiviert. Die Mail geht an die Rechnungsadresse des Kunden, mit PDF im Anhang und, falls veröffentlicht, mit Link zum Kundenportal.": "Each document is generated as a PDF and archived. The email goes to the customer's billing address with the PDF attached and, if published, a link to the customer portal.",
  "Wird ausgeführt …": "Running …",
} satisfies Record<string, string>;
